import SavingsStatCard from './SavingsStatCard';

export * from './SavingsStatCard';

export default SavingsStatCard;
